import React from "react";
import Layout from "../components/Layout";
const HomePage =()=>{
    return(
        <div className="home-page">
        <Layout />    
        </div>
    )
}
    export default HomePage;